function main() {
  const needResourceList = [
    window.$,
    window.jQuery,
    window.Swiper,
    window.Lazyload,
  ];

  if (needResourceList.filter(Boolean).length !== needResourceList.length) {
    return setTimeout(main, 240);
  }

  const prods = window.prods;

  let rootEle = document.getElementById("root");
  rootEle.style.zoom = "normal"; //避免zoom尺寸叠加
  let scale = rootEle.clientWidth / 1080;
  rootEle.style.zoom = scale;
  window.addEventListener("resize", function () {
    rootEle.style.zoom = "normal";
    let scale = rootEle.clientWidth / 1080;
    rootEle.style.zoom = scale;
  });

  var lazy = new Lazyload({ distance: 500 });

  jQuery("#nav1").slide({
    mainCell: ".nav11",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 7,
    easing: "swing",
  });

  jQuery("#nav22").slide({
    mainCell: ".nav22",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 8,
  });

  // 倒计时
  function getRandomNum(n, m) {
    let _num = Math.floor((n + 1 - m) * Math.random() + m);
    return _num;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);
    let leftTime = endTime.getTime() - nowTime.getTime();
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }

  function getCutDownTime() {
    let rHour = getRandomNum(4, 12);
    let curTime = new Date();
    endTimeG = curTime.setHours(curTime.getHours() + rHour);
    setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  // $(".sp_buy_now").on("click", function () {
  //   let id = $(this).attr("data-id");
  //   window.location.href = "/cart/" + id + ":1";
  // });
// 弹窗 start
   var main_id = "";
    $('.emitCheckout').click(function(){
      console.log('1111')
      main_id = $(this).data('id')
      // main_id = $(this).siblings('.select_span').find('span.on').data('id')
      // window.location.href = "/cart/" + id + ":1"
    })

  function getPopProdId(){
    let selectVals = [];
   $('.overbuy_wrap .sp-subopt.active').each(function(){
      selectVals.push($(this).data('val'))
    })

    let cur = popProduct.filter(item => {
      let option1 = selectVals[0];
      let option2 = null;
      let option3 = null;
      if(selectVals[1]){
        option2 = selectVals[1];
      }
      if(selectVals[2]){
        option3 = selectVals[2];
      }

      
      return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
    })

 
    
    return cur[0];
  }

  $('.overbuy-select div').click(function(){
     $(this).siblings().removeClass('active')
     $(this).addClass('active')
    let cur = getPopProdId();
    
    if(cur){
      $(".main-btn").removeClass("overbuy_disabled")
      let _price = parseFloat(cur.price / 100).toFixed(2);
      let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(2);
  
      $('.overbuy_price span').eq(0).html('€' + _price);
      $('.overbuy_price span').eq(1).html('€' + _compare_at_price);
    }else{
      $(".main-btn").addClass("overbuy_disabled")
    }
    
  })

  


  window.emitSubmit = function(_type){
    let num =1
     if(_type == 'all'){
      // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
      let _id = getPopProdId()?.id;
       if(!_id) return
      console.log(_id)
       
      window.location.href = `/cart/${main_id}:${num},${_id}:1`
    }else{
      window.location.href = `/cart/${main_id}:${num}`
    }
  }



  // 弹窗 end
  new Swiper("#banner1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    slidesPerView: "auto",
  });
  new Swiper("#swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    pagination: {
      el: ".pagination1",
      type: "bullets",
      clickable: true,
    },
  });

  $(".buy").click(function () {
    const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
    const offsetTop = targetElement.offsetTop;
    window.scroll({
      top: (offsetTop + 280) * $("div#root").css("zoom"),
      behavior: "smooth",
    });
  });
}

main();
